export const CONTACT_EMAIL = 'comunicaciones@certificadostradicionylibertad.co';

export const CITIES = {
  bogota:
  {
    titleSeo: "Comprar Certificado de Tradición y Libertad en Bogotá",
    metaDescription: `Descarga aquí tu Certificado de Tradición y Libertad en Bogotá de forma rápida y segura. 
    Tramitamos documentos oficiales sin filas ni complicaciones. ¡Simple y rápido!`,
    url: 'tradicion-y-libertad-bogota',
    displayName: 'Bogotá',
    banner: '1-bogota.webp',
    bannerSubtitle: 'Tu certificado de tradición y libertad en Bogotá. 100% en línea.',
    info1: {
      title: "Importancia del Certificado de Tradición y Libertad en Bogotá ",
      description: `El Certificado de Tradición y Libertad en Bogotá es un documento oficial expedido por la Superintendencia de Notariado y Registro, que contiene el historial jurídico de un inmueble ubicado en la ciudad.
      <br><br>
      ¿No sabes si tu predio está en la zona Norte, Centro o Sur? Los primeros dígitos de tu matrícula inmobiliaria lo indican: si comienza con 50N es Zona Norte, 50C es Zona Centro, y 50S es Zona Sur.`,
      img: '2-bogota.webp'
    },
    info2: {
      title: "¿Cómo identificar si un inmueble está en propiedad horizontal?",
      description: `En Bogotá, la mayoría de los inmuebles urbanos hacen parte de propiedad horizontal (PH), y esta condición debe estar registrada en el certificado.`,
    },
    whatsIncluded: {
      title: "¿Qué recibes al comprar tu certificado?",
      items: [
        "Un documento oficial en PDF, listo para descargar, expedido directamente por la Superintendencia de Notariado y Registro.",
        "Te llega a tu correo apenas se confirme el pago, sin esperas.",
        "Sirve para trámites bancarios, notariales, legales y de compraventa en toda Bogotá, incluidos los inmuebles en propiedad horizontal (apartamentos y conjuntos residenciales)."
      ]
    },
    faqTitle: "Preguntas frecuentes sobre el certificado en Bogotá",
    faq: [
      { q: "¿Cómo sé a cuál oficina de Bogotá pertenece mi predio?", a: "Bogotá es la única ciudad con tres oficinas de registro, y cada predio pertenece a una sola. Lo identificas por el número de la oficina, los tres primeros dígitos de la matrícula inmobiliaria: 50N → Zona Norte, 50C → Zona Centro, 50S → Zona Sur. Por ejemplo, una matrícula 50N-1234567 corresponde a la Zona Norte. Selecciona la oficina que coincida con ese número al hacer tu solicitud." },
      { q: "¿Qué pasa si elijo la zona equivocada?", a: "Como en Bogotá hay tres oficinas, es importante elegir la correcta. Si seleccionas una zona que no corresponde a tu matrícula, el sistema no encontrará el folio y no podrá generar el certificado. Antes de pagar, verifica que el número de la oficina de tu matrícula (50N, 50C o 50S) coincida con la oficina seleccionada." },
      { q: "¿Puedo pedir predios de distintas zonas de Bogotá en una sola compra?", a: "Sí. En una misma compra puedes incluir predios de la Zona Norte, Centro o Sur (e incluso de otras ciudades). Solo agrega cada matrícula seleccionando la oficina de registro que le corresponde según el número de la oficina (50N, 50C o 50S)." }
    ],
    priorityKeys: ['50C', '50N', '50S'],
    offices: [
      {
        location: 'Bogotá Norte',
        contacts: [
          { icon: 'map.svg', label: 'Dirección', value: 'Calle 74 no. 13 - 40' },
          { icon: 'call.svg', label: 'Teléfono', value: '(1) 3450500' },
          { icon: 'email.svg', label: 'Correo', value: 'ofiregisbogotanorte@supernotariado.gov.co' },
        ]
      },
      {
        location: 'Bogotá Centro',
        contacts: [
          { icon: 'map.svg', label: 'Dirección', value: 'Calle 28 no. 13 - 49 int. 201' },
          { icon: 'call.svg', label: 'Teléfono', value: '(1) 2860169' },
          { icon: 'email.svg', label: 'Correo', value: 'ofiregisbogotacentro@supernotariado.gov.co' },
        ]
      },
      {
        location: 'Bogotá Sur',
        contacts: [
          { icon: 'map.svg', label: 'Dirección', value: 'Calle 45A Sur # 52C-71' },
          { icon: 'call.svg', label: 'Teléfono', value: '(1) 2387791 (1) 2383780' },
          { icon: 'email.svg', label: 'Correo', value: 'ofiregisbogotasur@supernotariado.gov.co' },
        ]
      }
    ]
  },
  medellin:
  {
    titleSeo: "Comprar Certificado de Tradición y Libertad en Medellín",
    metaDescription: `Descarga tu Certificado de Tradición y Libertad en Medellín. Documento oficial sin filas ni desplazamientos.  
    ¡Trámite 100% en línea!`,
    url: 'tradicion-y-libertad-medellin',
    displayName: 'Medellín',
    banner: '1-medellin.webp',
    bannerSubtitle: 'Tu certificado de tradición y libertad en Medellín. En línea. Sin filas ni desplazamientos.',
    info1: {
      title: "Importancia del Certificado de Tradición y Libertad en Medellín",
      description: `En Medellín, este certificado es clave para conocer el estado legal de cualquier propiedad dentro del área metropolitana. Si estás comprando o vendiendo, necesitas este documento.
      <br><br>
      ¿Tu inmueble está en el Área Metropolitana? Estos municipios no tienen oficina de registro propia, así que su trámite se gestiona a través de las oficinas de Medellín: 
      <br><br>
      <ul class="medellin-info-list">
        <li>
          <span>Si tu predio está en Bello, Copacabana, Girardota o Barbosa, selecciona la oficina Medellín Norte.</span>
        </li>
        <li>
          <span>Si tu predio está en La Estrella, Sabaneta, Itagüí o Envigado, selecciona la oficina Medellín Sur.</span>
        </li>
      </ul>
      <br>
      <div class="medellin-info-footer">
        <div class="medellin-info-text">¿Quieres saber por qué funciona así? <a href="https://certificadostradicionylibertad.co/blog/post/certificado-de-tradicion-y-libertad-en-medellin-y-el-area-metropolitana/" class="medellin-info-link">Conoce más en nuestra guía completa.</a></div>
      </div>`,
      img: '2-medellin.webp'
    },
    info2: {
      title: "¿Qué pasa si un inmueble fue adjudicado por sucesión?",
      description: `Si el inmueble fue adjudicado por sucesión (herencia), el Certificado de Tradición y Libertad te permite verificar que la partición esté debidamente inscrita antes de comprar.
        `,
    },
    whatsIncluded: {
      title: "¿Qué incluye tu compra?",
      items: [
        "Documento oficial en PDF, expedido por la Superintendencia de Notariado y Registro.",
        "Entrega inmediata a tu correo electrónico una vez aprobado el pago.",
        "Válido para trámites bancarios, notariales, legales y de compraventa en Medellín y el área metropolitana."
      ]
    },
    faqTitle: "Preguntas frecuentes sobre el certificado en Medellín",
    faq: [
      { q: "¿Cómo sé si mi predio es Medellín Norte o Medellín Sur?", a: "Medellín tiene dos oficinas de registro, y cada predio pertenece a una sola. Lo identificas por el número de la oficina, los tres primeros dígitos de la matrícula inmobiliaria: <strong>001</strong> → Medellín Sur, <strong>01N</strong> → Medellín Norte. Selecciona la oficina que coincida con ese número al hacer tu solicitud." },
      { q: "¿Qué pasa si elijo la oficina equivocada?", a: "Como en Medellín hay dos oficinas, es importante elegir la correcta. Si seleccionas una que no corresponde a tu matrícula, el sistema no encontrará el folio y no podrá generar el certificado. Antes de pagar, verifica que el número de la oficina de tu matrícula (001 o 01N) coincida con la oficina seleccionada." },
      { q: "¿Mi predio está en un municipio del Área Metropolitana? ¿Lo puedo pedir aquí?", a: "Sí. Los municipios del Valle de Aburrá no tienen oficina de registro propia; su trámite se gestiona a través de las oficinas de Medellín. Si tu predio está en <strong>Bello, Copacabana, Girardota o Barbosa</strong>, selecciona <strong>Medellín Norte</strong>; si está en <strong>La Estrella, Sabaneta, Itagüí o Envigado</strong>, selecciona <strong>Medellín Sur.</strong>" }
    ],
    priorityKeys: ['001', '01N'],
    offices: [
      {
        location: 'Medellín Norte',
        contacts: [
          { icon: 'map.svg', label: 'Dirección', value: 'Carrera 47 no. 52-122 interior 201 centro comercial el paso' },
          { icon: 'call.svg', label: 'Teléfono', value: '(4)5128063 (4)5107070' },
          { icon: 'email.svg', label: 'Correo', value: 'ofiregismedellinnorte@supernotariado.gov.co' },
        ]
      },
      {
        location: 'Medellín Sur',
        contacts: [
          { icon: 'map.svg', label: 'Dirección', value: 'Carrera 52 no. 42 - 75 centro administrativo la alpujarra - edificio jose felix de restrepo' },
          { icon: 'call.svg', label: 'Teléfono', value: '(4) 3851000' },
          { icon: 'email.svg', label: 'Correo', value: 'ofiregismedellinzonasur@supernotariado.gov.co' },
        ]
      },
    ]
  },
  cali:
  {
    titleSeo: "Comprar Certificado de Tradición y Libertad en Cali",
    metaDescription: `Compra aquí tu Certificado de Tradición y Libertad en Cali sin salir de casa. Servicio oficial, 
    rápido y confiable para tus transacciones inmobiliarias. ¡Trámite 100% en línea!`,
    url: 'tradicion-y-libertad-cali',
    displayName: 'Cali',
    banner: '1-cali.webp',
    info1: {
      title: "Importancia del Certificado de Tradición y Libertad en Cali",
      description: `El Certificado de Tradición y Libertad en Cali garantiza la transparencia de cualquier operación inmobiliaria dentro del Valle del Cauca. Muestra si el inmueble tiene limitaciones o demandas judiciales, quiénes han sido sus propietarios y si hay hipotecas activas.`,
      img: '2-cali.webp'
    },
    info2: {
      title: "¿Cómo detectar si un inmueble en Cali fue objeto de restitución de tierras?",
      description: `En Cali y zonas rurales del Valle, algunas propiedades han sido objeto de procesos de <strong>restitución de tierras</strong>.
        El Certificado de Tradición y Libertad puede tener <strong>anotaciones relacionadas</strong> con procesos de restitución por desplazamiento forzado. 
        Si ves este alguna de las <strong>siguientes anotaciones</strong>, consulta con un abogado antes de comprar:
        <br><br>
        <ul class="medellin-info-list">
          <li><span>Anotaciones de restitución por sentencia judicial</span></li>
          <li><span>Procesos activos en la Unidad de Restitución de Tierras</span></li>
          <li><span>Inscripciones en el folio por pertenencia o posesión de hecho</span></li>
        </ul>
        `,
    },
    whatsIncluded: {
      title: "¿Qué obtienes al comprar tu certificado en Cali?",
      items: [
        "Un documento oficial en PDF, emitido por la Superintendencia de Notariado y Registro.",
        "Se envía a tu correo apenas se confirme el pago, sin filas ni desplazamientos.",
        "Te sirve para trámites bancarios, notariales, legales y de compraventa en Cali y el Valle del Cauca."
      ]
    },
    faqTitle: "Preguntas frecuentes sobre el certificado en Cali",
    faq: [
      { q: "¿Mi predio está en el Valle del Cauca pero no en Cali? ¿Lo pido aquí?", a: "No necesariamente. No todos los municipios del Valle se registran en la oficina de Cali; varios tienen su propia oficina de registro (por ejemplo, Palmira). Selecciona la oficina que corresponde al municipio de tu predio —la identificas por el número de la oficina, los tres primeros dígitos de tu matrícula— o consulta el <a href='/directorio/' class='medellin-info-link'>directorio completo de oficinas</a>." },
      { q: "¿Mi predio es rural o está en un corregimiento de Cali? ¿Cambia la oficina?", a: "No. Todos los predios del municipio de Cali —urbanos y rurales, incluidos los corregimientos— se registran en la misma oficina de Cali. Solo cambia de oficina si el predio está en otro municipio del Valle." },
      { q: "¿Qué hago si el certificado muestra un proceso de restitución de tierras?", a: "Consulta con un abogado antes de seguir con la compra; puede afectar la validez legal." }
    ],
    priorityKeys: ['Cali'],
    offices: [
      {
        location: 'Cali',
        contacts: [
          { icon: 'map.svg', label: 'Dirección', value: 'Carrera 56 no. 11 a - 20' },
          { icon: 'call.svg', label: 'Teléfono', value: '(2) 3301572' },
          { icon: 'email.svg', label: 'Correo', value: 'ofiregiscali@supernotariado.gov.co' },
        ]
      }
    ]
  },
  barranquilla:
  {
    titleSeo: "Comprar Certificado de Tradición y Libertad en Barranquilla",
    metaDescription: `¿Necesitas un Certificado de Tradición y Libertad en Barranquilla? Compralo aquí en minutos con nuestro servicio en línea. ¡Simple y rápido!`,
    url: 'tradicion-y-libertad-barranquilla',
    displayName: 'Barranquilla',
    banner: '1-barranquilla.webp',
    info1: {
      title: "Contenido del Certificado de Tradición y Libertad en Barranquilla",
      description: ` 
        <ul class="medellin-info-list">
          <li><span>Datos Generales del Inmueble</span></li>
          <li><span>Fecha de la última inscripción registrada</span></li>
          <li><span>Hipotecas, embargos o limitaciones</span></li>
          <li><span>Propietarios y Transacciones Inmobiliarias</span></li>
          <li><span>Detalles de la Superintendencia de Notariado y Registro</span></li>
          <li><span>Notas adicionales</span></li>
        </ul>
          `,
      img: '2-barranquilla.webp'
    },
    info2: {
      title: "¿Tu predio en Barranquilla tiene un englobamiento o desenglobe reciente?",
      description: `En Barranquilla es común encontrar terrenos que fueron divididos <strong>(desenglobados)</strong> o unificados <strong>(englobados)</strong>.
              El Certificado de Tradición y Libertad refleja estos <strong>cambios con claridad</strong>. Son operaciones que modifican el área, linderos o 
              matrícula de un predio. Verifica:
              <br><br>
              <ul class="medellin-info-list">
                <li><span>Que el número de matrícula sea el correcto (no una anterior)</span></li>
                <li><span>Que el certificado esté actualizado con el nuevo plano o escritura</span></li>
                <li><span>Que no haya sobreposición con otros predios</span></li>
              </ul>`,
    },
    whatsIncluded: {
      title: "Esto es lo que recibes al comprar",
      items: [
        "Tu certificado llega en PDF, directamente expedido por la Superintendencia de Notariado y Registro.",
        "Apenas se apruebe el pago, te llega al correo — no tienes que volver a la página.",
        "Aplica para trámites bancarios, notariales, legales y de compraventa en Barranquilla y Soledad."
      ]
    },
    faqTitle: "Preguntas frecuentes sobre el certificado en Barranquilla",
    faq: [
      { q: "¿Cuál es la oficina de registro de Barranquilla y su código?", a: "Los inmuebles del municipio de Barranquilla se registran en la Oficina de Registro de Instrumentos Públicos (ORIP) de Barranquilla, con código <strong>040</strong>; por eso su número de matrícula inmobiliaria inicia con 040. Los predios de <strong>Soledad</strong>, en cambio, se registran en su propia oficina (código <strong>041</strong>), aunque haga parte del área metropolitana." },
      { q: "¿Mi predio está en Soledad? ¿Lo pido aquí?", a: "Sí. Soledad hace parte del área metropolitana de Barranquilla, pero cuenta con su propia oficina de registro, distinta a la de Barranquilla. Por eso, si tu predio está en Soledad, en el formulario debes seleccionar la oficina de <strong>Soledad</strong> —no la de Barranquilla— para que el sistema encuentre el folio y genere tu certificado. El precio y el proceso son exactamente los mismos." },
      { q: "¿Qué pasa si elijo la oficina equivocada?", a: "Barranquilla y Soledad son dos oficinas de registro independientes. Si seleccionas una que no corresponde al municipio donde está el predio, el sistema no encontrará el folio y no podrá generar el certificado. Antes de pagar, verifica que la oficina seleccionada coincida con el municipio real del inmueble; puedes confirmarlo con el número de la oficina, los tres primeros dígitos de la matrícula (040 Barranquilla, 041 Soledad)." },
      { q: "¿Mi predio está en otro municipio del Atlántico (Malambo, Galapa, Puerto Colombia…)?", a: "No todos los municipios del Atlántico se registran en la oficina de Barranquilla; algunos tienen su propia oficina de registro. Selecciona la que corresponde al municipio donde está ubicado el predio —la identificas por el número de la oficina, los tres primeros dígitos de tu matrícula— o consulta el <a href='/directorio/' class='medellin-info-link'>directorio completo de oficinas</a>." }
    ],
    officeFooterNote: "¿Tu inmueble está en Soledad? También puedes tramitarlo aquí: solo selecciona la oficina de Soledad.",
    priorityKeys: ['Barranquilla'],
    offices: [
      {
        location: 'Barranquilla',
        contacts: [
          { icon: 'map.svg', label: 'Dirección', value: 'Carrera 42 d1 no. 80 a - 136' },
          { icon: 'call.svg', label: 'Teléfono', value: '(5) 3786674' },
          { icon: 'email.svg', label: 'Correo', value: 'ofiregisbarranquilla@supernotariado.gov' },
        ]
      },
      {
        location: 'Soledad',
        contacts: [
          { icon: 'map.svg', label: 'Dirección', value: 'Centro comercial plaza de la arboleda - piso 2' },
          { icon: 'call.svg', label: 'Teléfono', value: '(5) 3930029' },
          { icon: 'email.svg', label: 'Correo', value: 'ofiregissoledad@supernotariado.gov.co' },
        ]
      },
    ]
  },
  cartagena:
  {
    titleSeo: "Comprar Certificado de Tradición y Libertad en Cartagena ",
    metaDescription: `Descargar aquí tu Certificado de Tradición y Libertad en Cartagena con validez legal garantizada.
    Proceso 100% digital para tus trámites inmobiliarios.`,
    url: 'tradicion-y-libertad-cartagena',
    displayName: 'Cartagena',
    banner: '1-cartagena.webp',
    info1: {
      title: "Datos para obtener el Certificado de Tradición y Libertad en Cartagena",
      description: `El certificado se emite indicando el <strong>Número de matrícula inmobiliaria</strong>.  
      Este número es único para cada propiedad en Colombia y puede obtenerse de la <strong>escritura pública</strong> del predio.`,
      img: '2-cartagena.webp'
    },
    info2: {
      title: "¿Cómo saber si un predio en Cartagena tiene afectación por zonas de protección costera?",
      description: `Cartagena tiene reglamentaciones especiales sobre predios en <strong>zonas costeras</strong> y de <strong>reserva ecológica</strong>.
              <br><br>
              El Certificado de Tradición y Libertad puede incluir <strong>anotaciones</strong> por parte de DIMAR, Parques Nacionales o autoridades ambientales, 
              indicando restricciones al uso del suelo.
              <br><br>
              Verifica en el <strong>Certifiado de Tradición y Libertad</strong> alguna de las siguientes anotaciones a tener en cuenta: 
              <br><br>
              <ul class="medellin-info-list">
                <li><span>Afectaciones por zona de reserva ambiental.</span></li>
                <li><span>Restricciones de construcción en franja de playa.</span></li>
                <li><span>Limitaciones impuestas por planeación distrital.</span></li>
              </ul>`,
    },
    whatsIncluded: {
      title: "Con tu compra obtienes",
      items: [
        "Un PDF oficial, expedido por la Superintendencia de Notariado y Registro.",
        "Envío automático a tu correo tan pronto se confirme el pago.",
        "Validez para trámites bancarios, notariales, legales y de compraventa en Cartagena."
      ]
    },
    faqTitle: "Preguntas frecuentes sobre el certificado en Cartagena",
    faq: [
      { q: "¿Cuál es la oficina de registro de Cartagena y su código?", a: "Los inmuebles del Distrito de Cartagena se registran en la Oficina de Registro de Instrumentos Públicos (ORIP) de Cartagena, con código <strong>060</strong>. Por eso el número de matrícula inmobiliaria de los predios de la ciudad inicia con 060." },
      { q: "¿Mi predio está en Bolívar pero no en Cartagena? ¿Lo pido aquí?", a: "No necesariamente. El departamento de Bolívar tiene varias oficinas de registro, y no todos sus municipios se tramitan en la de Cartagena. Selecciona la oficina que corresponde al municipio donde está ubicado el predio —la identificas por el número de la oficina, los tres primeros dígitos de tu matrícula— o consulta el <a href='/directorio/' class='medellin-info-link'>directorio completo de oficinas</a> para encontrar la que aplica a tu caso." },
      { q: "¿Un predio rural o insular de Cartagena (Barú, Tierrabomba, Islas del Rosario) cambia la oficina?", a: "No. Barú, Tierrabomba, las Islas del Rosario y demás zonas rurales e insulares hacen parte del Distrito de Cartagena, así que todos sus predios se registran en la misma oficina de Cartagena. No importa si el inmueble es urbano, rural o insular: la oficina y el proceso son los mismos." },
      { q: "¿Mi predio está en zona costera, qué debo revisar?", a: "Si el inmueble está sobre la línea de costa o cerca de ella, revisa que en el certificado no aparezcan anotaciones relacionadas con bienes de uso público o zonas de bajamar. En particular, verifica que no haya limitaciones registradas por la <strong>DIMAR</strong>, por <strong>Parques Nacionales Naturales</strong> o por <strong>planeación distrital</strong>, ya que pueden afectar el uso o la titularidad del predio." }
    ],
    priorityKeys: ['Cartagena'],
    offices: [
      {
        location: 'Cartagena',
        contacts: [
          { icon: 'map.svg', label: 'Dirección', value: 'Calle baloco no. 2 - 40' },
          { icon: 'call.svg', label: 'Teléfono', value: '(5) 6641323' },
          { icon: 'email.svg', label: 'Correo', value: 'ofiregiscartagena@supernotariado.gov.co' },
        ]
      }
    ]
  },
  bucaramanga:
  {
    titleSeo: "Comprar Certificado de Tradición y Libertad en Bucaramanga",
    metaDescription: `Compra aquí tu Certificado de Tradición y Libertad en Bucaramanga al instante. 
    Trámite seguro con pago en línea y descarga inmediata a tu correo.`,
    url: 'tradicion-y-libertad-bucaramanga',
    displayName: 'Bucaramanga',
    banner: '1-bucaramanga.webp',
    info1: {
      title: "Utilidades del Certificado de Tradición y Libertad en Bucaramanga",
      description: `Este certificado es necesario en diversas situaciones, como:
      <br>
      <br>
      <ul class="medellin-info-list">
        <li><span><strong>Compra y venta</strong> de propiedades.</span></li>
        <li><span>Solicitudes de <strong>hipotecas</strong>.</span></li>
        <li><span>Procesos <strong>legales</strong> relacionados con propiedades.</span></li>
        <li><span>Cualquier trámite en el que se esté involucrado un inmueble.</span></li>
      </ul>`,
      img: '2-bucaramanga.webp'
    },
    info2: {
      title: "¿Está registrada en el certificado la construcción o solo el terreno en Bucaramanga?",
      description: `En Bucaramanga es común encontrar casos donde solo el terreno está <strong>legalmente registrado</strong>, pero no la construcción.
      <br><br>
      El Certificado de Tradición y Libertad puede mostrar si se ha inscrito la escritura de la mejora (la casa o construcción). 
      Revise especificamente si el certificado incluye la edificación, fecha de inscripción de mejoras y si existencia de licencia de construcción. 
      <br><br>
      Esto afecta el avalúo, los impuestos y la posibilidad de vender con valor agregado.


`,
    },
    whatsIncluded: {
      title: "Lo que obtienes con tu compra",
      items: [
        "Documento oficial en PDF, emitido por la Superintendencia de Notariado y Registro.",
        "Llega a tu correo apenas se apruebe el pago.",
        "Sirve para trámites bancarios, notariales, legales y de compraventa en Bucaramanga."
      ]
    },
    faqTitle: "Preguntas frecuentes sobre el certificado en Bucaramanga",
    faq: [
      { q: "¿Cuál es la oficina de registro de Bucaramanga y su código?", a: "Los inmuebles del municipio de Bucaramanga se registran en la Oficina de Registro de Instrumentos Públicos (ORIP) de Bucaramanga, con código <strong>300</strong>. Por eso el número de matrícula inmobiliaria de los predios de la ciudad inicia con 300." },
      { q: "¿Un predio del área metropolitana (Floridablanca, Girón, Piedecuesta) se pide aquí?", a: "No siempre. Municipios como <strong>Floridablanca</strong> y <strong>Piedecuesta</strong> tienen su propia oficina de registro, distinta a la de Bucaramanga, y <strong>Girón</strong> puede corresponder a otro círculo registral. Si tu predio está fuera del municipio de Bucaramanga, selecciona la oficina que corresponda al municipio del inmueble —la identificas por el número de la oficina, los tres primeros dígitos de tu matrícula— o consulta el <a href='/directorio/' class='medellin-info-link'>directorio completo de oficinas</a>. Solo los predios dentro del municipio de Bucaramanga usan la ORIP 300." },
      { q: "¿Un predio rural o de un corregimiento de Bucaramanga cambia la oficina?", a: "No. Los corregimientos y zonas rurales que hacen parte del municipio de Bucaramanga se registran en la misma oficina de Bucaramanga. Solo cambia la oficina si el predio está en un municipio distinto." },
      { q: "¿Cómo sé si mi construcción está registrada y no solo el terreno?", a: "Revisa que en el certificado la descripción del inmueble incluya la edificación y no únicamente el lote. Son buena señal la inscripción de mejoras o de la construcción con su fecha, y que figure la licencia de construcción. Si el folio solo menciona el terreno, es posible que la construcción no esté formalizada ante registro —algo importante de verificar antes de comprar o de pedir un crédito." }
    ],
    priorityKeys: ['Bucaramanga'],
    offices: [
      {
        location: 'Bucaramanga',
        contacts: [
          { icon: 'map.svg', label: 'Dirección', value: 'Carrera 20 no. 34 - 01' },
          { icon: 'call.svg', label: 'Teléfono', value: '(7) 6521311' },
          { icon: 'email.svg', label: 'Correo', value: 'ofiregisbucaramanga@supernotariado.gov.co' },
        ]
      }
    ]
  },
  santaMarta:
  {
    titleSeo: "Comprar Certificado de Tradición y Libertad en Santa Marta",
    metaDescription: `Solicita aquí tu Certificado de Tradición y Libertad en Santa Marta en minutos. 
    Documento oficial para compraventas, hipotecas y trámites bancarios.`,
    url: 'tradicion-y-libertad-santa-marta',
    displayName: 'Santa Marta',
    banner: '1-santa-marta.webp',
    info1: {
      title: "Importancia del Certificado de Tradición y Libertad en Santa Marta",
      description: `Este certificado recopila la información más relevante sobre un inmueble, desde su <strong>registro inicial</strong> hasta su <strong>situación actual</strong>, 
      permitiendo que compradores, vendedores y entidades jurídicas verifiquen todo lo relacionado con <strong>el predio</strong>.`,
      img: '2-santa-marta.webp'
    },
    info2: {
      title: "¿Cómo identificar predios en Santa Marta con procesos de pertenencia en curso?",
      description: `En Santa Marta hay propiedades en zonas rurales o de expansión urbana en donde se han iniciado <strong>procesos de pertenencia</strong>.
      <br><br>
      El Certificado de Tradición y Libertad puede tener una anotación que diga: <strong>“Se encuentra en curso proceso de pertenencia”</strong>. Esto implica que alguien está reclamando 
      legalmente la propiedad del predio por posesión prolongada.
      <br><br>
      Es relevante identificar esta <strong>anotación</strong> ya que puede indicar que El actual "propietario" podría no ser el titular legal, la sentencia de pertenencia podría estar en 
      trámite y no podrías escriturar hasta que el proceso termine. 
      `,
    },
    whatsIncluded: {
      title: "Tu compra incluye",
      items: [
        "Un documento oficial en PDF, expedido por la Superintendencia de Notariado y Registro.",
        "Se envía a tu correo automáticamente al aprobarse el pago.",
        "Sirve para trámites bancarios, notariales, legales y de compraventa en Santa Marta."
      ]
    },
    faqTitle: "Preguntas frecuentes sobre el certificado en Santa Marta",
    faq: [
      { q: "¿Cuál es la oficina de registro de Santa Marta y su código?", a: "Los inmuebles del Distrito de Santa Marta se registran en la Oficina de Registro de Instrumentos Públicos (ORIP) de Santa Marta, con código <strong>080</strong>. Por eso el número de matrícula inmobiliaria de los predios de la ciudad inicia con 080." },
      { q: "¿Mi predio está en el Magdalena pero no en Santa Marta? ¿Lo pido aquí?", a: "No necesariamente. El departamento del Magdalena tiene varias oficinas de registro, y no todos sus municipios se tramitan en la de Santa Marta. Selecciona la oficina que corresponde al municipio donde está ubicado el predio —la identificas por el número de la oficina, los tres primeros dígitos de tu matrícula— o consulta el <a href='/directorio/' class='medellin-info-link'>directorio completo de oficinas</a> para ubicar la correcta." },
      { q: "¿Un predio rural o en la Sierra Nevada (Minca, Guachaca, Bonda) cambia la oficina?", a: "No. Minca, Guachaca, Bonda y las demás zonas rurales de la Sierra Nevada hacen parte del Distrito de Santa Marta, así que sus predios se registran en la misma oficina de Santa Marta. Ya sea un apartamento en el Rodadero o una finca en la Sierra, la oficina y el proceso son los mismos." },
      { q: "¿Qué significa que aparezca un proceso de pertenencia en curso?", a: "Significa que una persona está reclamando la propiedad del inmueble alegando haberlo poseído de forma prolongada y pública. Mientras ese proceso esté en curso, quien figura como titular en el certificado podría no terminar siendo el propietario legal del predio. Si ves esta anotación, consulta con un abogado antes de avanzar en la compra, porque el resultado del proceso puede cambiar quién es el dueño." }
    ],
    priorityKeys: ['Santa Marta'],
    offices: [
      {
        location: 'Santa Marta',
        contacts: [
          { icon: 'map.svg', label: 'Dirección', value: 'Avenida Libertador # 29-67' },
          { icon: 'call.svg', label: 'Teléfono', value: '(5) 4211244' },
          { icon: 'email.svg', label: 'Correo', value: 'ofiregissantamarta@supernotariado.gov.co' },
        ]
      }
    ]
  }
};